import RewardsTabs from './Components/RewardTab';
import { REWARD_TABS } from './utils';
import { useCleverTapPageTracking } from '../../../utils/clevertap';

const MyRewards = () => {
  useCleverTapPageTracking('My_Rewards', 'rewards');
  
  return <RewardsTabs allowedTabs={[REWARD_TABS['INFLUENCER'], REWARD_TABS['SELF']]} />;
};

export default MyRewards;
